import * as React from 'react';

import {Body} from 'shells/typography/body';

import type {BillingInfo_addressInfo as Address} from 'nutshell-graphql-types';

type Props = {
    companyName: string;
    addressInfo: Address;
};

export function AddressInfo(props: Props) {
    return (
        <div>
            <Body as='div' size='small'>
                {props.companyName}
            </Body>
            <Body as='div' size='small'>
                {props.addressInfo.address1}
            </Body>
            {props.addressInfo.address2 && (
                <Body as='div' size='small'>
                    {props.addressInfo.address2}
                </Body>
            )}
            <Body as='div' size='small'>
                {props.addressInfo.city}, {props.addressInfo.state}, {props.addressInfo.postal}
            </Body>
            <Body as='div' size='small'>
                {props.addressInfo.country}
            </Body>
        </div>
    );
}
